const initialState = {
  country: {},
  inviteUserModalOpened: false,
};

const initialStateForTest = {
  country: {},
  inviteUserModalOpened: false,
};

export default initialState;
export { initialStateForTest };
